import type { PostHogConfig } from 'posthog-js';
import { readPostHogDistinctId } from '@/lib/cookies';
import { tikTokDistinctIdFromRequest } from '@/utils/tiktokIdentity';

/**
 * The `bootstrap` option for posthog.init: the flags the edge delivered plus the id it evaluated
 * them under, resolved in the same order the middleware used. Passing the id makes posthog-js adopt
 * it over any stored one, so the client resolves the same variant the edge served.
 */
export function buildBootstrap(
	flags: Record<string, string | boolean>,
	params: URLSearchParams,
	userAgent: string | null | undefined,
): PostHogConfig['bootstrap'] | undefined {
	const hasFlags = Object.keys(flags).length > 0;
	const distinctID = readPostHogDistinctId() ?? tikTokDistinctIdFromRequest(params, userAgent);
	if (!hasFlags && !distinctID) return undefined;

	const bootstrap: NonNullable<PostHogConfig['bootstrap']> = {};
	// Each key is set only when it has a value. An empty featureFlags object is not equivalent to
	// omitting it: posthog-js would read it as "flags are already bootstrapped" and skip fetching them.
	if (hasFlags) bootstrap.featureFlags = flags;
	if (distinctID) bootstrap.distinctID = distinctID;
	return bootstrap;
}
